import React, { useRef, useState } from "react";
import sortIcon from "../../../../assets/images/arrowIcon.svg";
import columnSelectorIcon from "../../../../assets/images/columnSelectIcon.svg";
import searchIcon from "../../../../assets/images/searchIcon.svg";
import closeIcon from "../../../../assets/images/CloseIcon.svg";
import CustomPagination from "../../../../components/pagination/CustomPagination";

function InvoicesTable({
  showEmptyScreen,
  tableHeadData,
  handleSort,
  selectedHeader,
  handleArrowSortClick,
  tableBodyData,
  singleDetailPath,
  setSelectedOption,
  page,
  setPage,
  size,
  setSize,
  total,
  columnDropdownOpen,
  setColumnDropdownOpen,
  handleSiteSearch,
  resetHandler,
  handleClickItem,
}: any) {
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const [closeSearchBarIfValue, setCloseSearchBarIfValue] = useState(true);
  const [searchText, setSearchText] = useState("");

  const searchRef: any = useRef();

  const handleOutsideClickSearch = (event: any) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      if (!closeSearchBarIfValue) {
        setSearchBarOpen(true);
      } else {
        setSearchBarOpen(false);
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClickSearch);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClickSearch);
    };

    // eslint-disable-next-line
  }, [closeSearchBarIfValue]);

  return (
    <div className="payment-card-wrap mt-2 w-100 h-100">
      <div className="d-flex justify-content-between align-items-center">
        <div style={{ color: "#2D9CDB", fontSize: "14px", fontWeight: 700 }}>EXPORT</div>
        <div className="d-flex" style={{ gap: "2rem" }}>
          <div className="w-100" style={{ minWidth: "40rem" }}>
            <div className="searchIcon-wrap" ref={searchRef} style={{ position: "relative", width: searchBarOpen ? "100%" : "inherit" }}>
              <div style={{ width: "100%", height: "34px" }}>
                {searchBarOpen ? (
                  <input
                    value={searchText}
                    onChange={(e: any) => {
                      setSearchText(e?.target?.value);
                      handleSiteSearch(e.target.value);
                      if (e?.target?.value?.length === 0) {
                        setCloseSearchBarIfValue(true);
                      } else {
                        setCloseSearchBarIfValue(false);
                      }
                    }}
                    type="text"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                      background: "#F2F2F2",
                      borderRadius: "6px",
                      padding: "1rem",
                      color: searchText?.length ? "#4F4F4F" : "#BDBDBD",
                      fontWeight: !searchText?.length ? 500 : 700,
                    }}
                    className="searchBar"
                    placeholder="Search"
                  />
                ) : null}

                <div style={{ position: "absolute", top: 3, right: "20px" }}>
                  {searchText?.length && searchBarOpen ? (
                    <img
                      src={closeIcon}
                      alt="search icon"
                      onClick={() => {
                        setSearchText("");
                        resetHandler();
                        setCloseSearchBarIfValue(true);
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt="search icon"
                      onClick={() => {
                        setSearchBarOpen(!searchBarOpen);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              setColumnDropdownOpen(!columnDropdownOpen);
            }}
          >
            <img src={columnSelectorIcon} alt="select-cols-icon" />
          </div>
        </div>
      </div>
      <div className={`mt-3 ${!showEmptyScreen ? "custom-table-responsive" : "custom-table-responsive-specific"} table-responsive`}>
        <table className="table-main-customized table">
          <thead>
            <tr className="table-header">
              {tableHeadData
                ?.filter((item: any) => item?.isSelected)
                ?.map((item: any, index: number) => {
                  return (
                    <th key={index}>
                      <div className="d-flex">
                        <span
                          style={{ cursor: "pointer", whiteSpace: "nowrap", fontSize: 12, fontWeight: 700, color: "#828282" }}
                          onClick={() => {
                            handleSort(item);
                          }}
                        >
                          {item?.label}
                        </span>
                        {selectedHeader?.value === item?.value ? (
                          <img
                            className="ml-2 mt-1"
                            id="sort-icon"
                            src={sortIcon}
                            alt="sort-arrow"
                            onClick={handleArrowSortClick}
                            style={{
                              verticalAlign: "initial",
                              cursor: "pointer",
                              zIndex: "99",
                              color: "inherit",
                              marginBottom: "6px",
                              transform: `${selectedHeader?.sortBy === "desc" ? "rotate(180deg)" : "rotate(360deg)"}`,
                            }}
                          />
                        ) : null}
                      </div>
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>
            {!showEmptyScreen &&
              tableBodyData?.map((item: any, index: number) => {
                return (
                  <tr
                    key={index}
                    onClick={() => {
                      handleClickItem(item);
                    }}
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#333333",
                      borderBottom: "none",
                      cursor:"pointer"
                    }}
                  >
                    {tableHeadData
                      ?.filter((item: any) => item?.isSelected)
                      ?.map((subItem: any, index: number) => {
                        return (
                          <td key={index}>
                            <span> {item[`${subItem?.value}`]}</span>
                          </td>
                        );
                      })}
                  </tr>
                );
              })}
          </tbody>
        </table>
        <div className="mx-3">
          <CustomPagination page={+page} setSize={setSize} setpage={setPage} size={+size} total={+total} filterCount={+total} />
        </div>
      </div>
    </div>
  );
}

export default InvoicesTable;
